/* eslint-disable max-lines-per-function */
import React, { useEffect, useState, ChangeEvent } from 'react';
import withFilter from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/filter';
import { ModalSheet } from '../ModalSheet';
import { Wrapper, SortIcon, Label, SortTitle, Option } from './Styled';
import { ISelectSort } from '../../../types';

export const SelectSortComponent = ({ onChangeNew }: ISelectSort) => {
  const [visible, setVisible] = useState(false);
  const [label, setLabel] = useState('mais úteis');
  const exitFunc = () => setVisible(false);
  const toggleModal = React.useCallback(() => setVisible(!visible), [visible]);

  const onChangeFunc = (e: unknown) => {
    setLabel((e as ChangeEvent).target.id);
    setVisible(false);
    onChangeNew(e);
  };

  useEffect(() => {
    const handleAfterClick = (e: unknown) => {
      const clickOutside = (e as ChangeEvent).target.className.includes('src__Wrapper');
      if (clickOutside) {
        toggleModal();
      }
    };

    if (visible) {
      document.addEventListener('click', handleAfterClick);
    }

    return () => {
      document.removeEventListener('click', handleAfterClick);
    };
  }, [visible, toggleModal]);

  return (
    <>
      <Wrapper onClick={toggleModal}>
        <SortIcon />
        <SortTitle>ordenar</SortTitle>
        <Label>{label}</Label>
      </Wrapper>
      <ModalSheet visible={visible} title="ordenar por" exitFunc={exitFunc}>
        <Option onClick={onChangeFunc}>
          <input
            key="mais úteis"
            type="radio"
            id="mais-uteis"
            name="mais úteis"
            checked={label === 'mais úteis'}
            onChange={() => null}
            value="likes"
          />
          <label htmlFor="mais úteis" id="mais uteis">
            mais úteis
          </label>
        </Option>
        <Option onClick={onChangeFunc}>
          <input
            type="radio"
            id="mais-recentes"
            name="mais recentes"
            checked={label === 'mais recentes'}
            onChange={() => null}
            value="descending"
            key="mais recentes"
          />
          <label id="mais recentes">mais recentes</label>
        </Option>
        <Option onClick={onChangeFunc}>
          <input
            key="mais antigas"
            type="radio"
            id="mais-antigas"
            name="mais antigas"
            checked={label === 'mais antigas'}
            onChange={() => null}
            value="ascending"
          />
          <label htmlFor="mais antigas" id="mais antigas">
            mais antigas
          </label>
        </Option>
      </ModalSheet>
    </>
  );
};

const SelectSort = withFilter(SelectSortComponent);

export { SelectSort };
